import { mapState, mapGetters } from 'vuex'
import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter

const navigateMixin = {
  data () {
    return {
      // fix double-click to link, which url is computed with 'this.$route.path'
      navigationInProgress: false
    }
  },

  computed: {
    ...mapGetters('common', ['isVirtual']),

    isMobile () {
      return this.$vuetify.breakpoint.mobile
    }
  },

  methods: {
    navigateTo (to, makeScroll = true) {
      if (this.navigationInProgress) {
        return false
      }

      this.navigationInProgress = true
      let link = ''
      const roomId = this.$route.params.roomId

      if (typeof to === 'string' || ('name' in to && !('slug' in to))) {
        link = to
      } else if ('route' in to) {
        link = to.route
      } else if (to.module == 'external_link') {
        // no router navigation follows, so release the double-click guard right away (otherwise every
        // later item of this menu stays dead)
        window.open(to.config, '_blank')
        this.navigationInProgress = false
        return
      } else {
        link = `/${to.slug}`

        if (roomId) {
          link = `/room-${roomId}${link}`
        }
      }

      this.$router.push(link)
        .then(() => {
          if (makeScroll && this.isVirtual && this.isMobile && typeof this.scrollUnderVideo === 'function') {
            this.scrollUnderVideo()
          }
        })
        .catch(error => {
          if (isNavigationFailure(error, NavigationFailureType.duplicated) && this.isMobile) {
            this.drawer = false
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.navigationInProgress = false
          }, 500)
        })

      if ('isMiniMenu' in this) {
        this.isMiniMenu = true
      }
    },

    logout (reason) {
      localStorage.removeItem('user')
      if (reason == 'another_device') {
        sessionStorage.setItem('logout_reason', reason)
        location.href = '/'
      } else {
        location.href = '/logout'
      }
    },

    toParent () {
      if (this.parent == null) return
      this.$router.push(this.parent).catch(() => {})
    },

    switchLocale (lang) {
      location.href = '/locale/' + lang.code
    },
  }
}

export default navigateMixin
